import React, { Component } from 'react';
import { Icon, Tree, Popover, Checkbox, Button, Input } from 'antd';
import Label from './label';
import text from './text';
const TreeNode = Tree.TreeNode;
const Search = Input.Search;
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import { findDOMNode } from 'react-dom';
import { debug } from 'util';

function flattenDeep(arr1) {
   return arr1.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
}

export default class TreeRefer extends Component {
  constructor(props) {
    super(props);
    const { cStyle } = this.props;
    if (cStyle) {
      let config = null;
      try {
        config = JSON.parse(cStyle);
      } catch (e) {
        config = {};
      }
      this.refresh = config.refresh;
      this.titleField = config.titleField;
    }
    this.titleField = props.titleField;
    this.cRefType = "default";
    if (this.props.model) {
      this.cRefType = this.props.model.get("cRefType");
    }
    this.userId = cb.rest.AppContext.user.id;
    this.storageKey = this.userId + "_" + this.cRefType;
    this.state = {
      bIsNull: props.bIsNull,
      showPop: false,
      checkedKeys: [],
      halfCheckedKeys: [],
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      visible: !props.bHidden,
      bLinkage: this.getLocalStorege(),/*上级联动下级*/
    };
    this.expandedKeys = [];
    this.selectedKeys = [];
    this.checkedKeys = [];
  }
  componentDidMount() {
    if (this.props.model) {
      this.props.model.addListener(this);
      const parent = this.props.model.getParent();
      if (parent)
        parent.on('updateTreeRefer', () => this.onClick());
    }
    if (this.props.focus)
      this.refs.input.refs.input.focus();
    // this.onClick();
    this.setState({ popWidth: this.input.clientWidth });
  }
  componentDidUpdate() {
    let { value } = this.state;
    if (!value) {
      this.selectedKeys = [];
    }
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillUnmount() {
    let model = this.getModel();
    this.selectedKeys = [];
    if (model)
      model.removeListener(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value)
      this.setState({ value: nextProps.value });
    if (nextProps.model) {
      if (!this.props.model) {
        nextProps.model.addListener(this);
      } else {
        return;
      }
    } else {
      if (this.props.model) {
        this.props.model.removeListener(this);
      }
    }
  }
  open = (e) => {
    this.referViewModel = e.vm;
    this.treeModel = e.vm.get('tree');
    this.treeModel.addListener(this);
    if (typeof this.props.afterOkClick === 'function')
      this.referViewModel.on('afterOkClick', this.props.afterOkClick);
  }
  setListenerState(params) {
    let { value,keyField } = params;
    delete params.value;
    delete params.checkedKeys
    const { select } = this.state;
    if (select && select.length) {
      const checkedKeys = [];
      select.forEach(item => {
        checkedKeys.push(item[keyField].toString());
      });
      params.checkedKeys = checkedKeys;
    }
    this.setState(params);
    if (value)
      this.setValue(value);
  }
  setValue = (value) => {
    if (cb.utils.isArray(value)) return;
    this.setState({ value });
  }
  setDataSource = (dataSource) => {
    let {value,titleField,keyField,value1,valueField} = this.state;
    const mainTitleField = titleField && titleField.split(',')[0];
    let _selectedKeys =[]; // 选中的值
    if(value1 && value && dataSource && dataSource.length){ // 过滤的filter会有 value1
      _selectedKeys = this.findSelectedKeys(dataSource,value1,keyField,valueField)
    }else if(value && dataSource && dataSource.length){ // 普通的treerefer 只会有value
      _selectedKeys = this.findSelectedKeys(dataSource,value,keyField,mainTitleField)
    }
    _selectedKeys = flattenDeep(_selectedKeys) // es 新语法，降维
    this.referViewModel.execute('beforeAutoSelectKeys', {keyField: keyField, dataSource: dataSource, keys: _selectedKeys});
    this.selectedKeys = _selectedKeys;
    this.checkedKeys = _selectedKeys;
    this.setState({ dataSource });
  }
  getModel = () => {
    return this.props.model || this.model;
  }
  handleClick = () => {
    if (this.state.disabled) return;
    if (!this.refresh) {
      if (this.hasClicked) return;
      this.hasClicked = true;
    }
    this.onClick();
  }
  onClick = () => {
    let model = this.getModel();
    if (!model && this.props.cRefType) {
      this.model = new cb.models.ReferModel({ cRefType: this.props.cRefType, multiple: this.props.multiple, isList: this.props.isList ? true : false, value: this.props.value });
      this.model.addListener(this);
    }
    model = this.getModel();
    if (model)
      model.browse();
  }
  handleJointQuery = () => {
    let model = this.getModel();
    if (!model && this.props.cRefType) {
      this.model = new cb.models.ReferModel({ cRefType: this.props.cRefType, multiple: this.props.multiple, isList: this.props.isList ? true : false, value: this.props.value });
      this.model.addListener(this);
    }
    model = this.getModel();
    if (model)
      model.fireEvent('jointQuery');
  }
  onSelect = (selectedKeys, e) => {
    let { multiple } = this.state;
    if (this.props.onSelect)
      this.props.onSelect(selectedKeys, e);
    if (this.treeModel)
      this.treeModel.select(selectedKeys);
    this.setState({ showPop: false });
    this.selectedKeys = selectedKeys;
    this.referViewModel.execute('afterOkClick', multiple ? this.treeModel.getCheckedNodes() : this.treeModel.getSelectedNodes());
  }
  /*pop点击事件*/
  onPopClick = () => {
    let {disabled,value} = this.state;
    if (disabled) return;
    this.checkedKeys = (cb.utils.isArray(value)? value: [value]);
    this.setState({
      showPop: !this.state.showPop
    });
  }
  onCheck = (checkedKeys, e) => {
    // filter 里面 checkedKeys会是一个数组
    checkedKeys = cb.utils.isArray(checkedKeys)? checkedKeys.filter(v=>!!v) : checkedKeys;
    let bLinkage = this.state.bLinkage;
    let checkKeys, halfCheckKeys;
    if (checkedKeys.checked) {
      checkKeys = checkedKeys.checked;
      halfCheckKeys = checkedKeys.halfChecked;
    } else {
      checkKeys = checkedKeys;
      halfCheckKeys = e.halfCheckedKeys;
    }
    if (bLinkage)
      this.changeLinkage(checkKeys, halfCheckKeys, e)
    else {
      if (this.treeModel) {
        this.treeModel._set_data('checkedKeys', checkKeys, true);
      }
      this.selectedKeys = checkedKeys
      this.checkedKeys = checkKeys
      this.setState({ checkedKeys: checkKeys, halfCheckedKeys: halfCheckKeys });
    }
  }
  changeLinkage = (checkKeys, halfCheckKeys, e) => {
    let key = e.node.props.eventKey;
    if (!this.keyMap)
      this.keyMap = this.treeModel.get('keyMap');
    let node = this.keyMap[key];
    if (e.checked)
      checkKeys.pop();
    checkKeys = this.loopTreeNodes(node, checkKeys, e.checked);
    this.checkedKeys = checkKeys
    this.setState({ checkedKeys: checkKeys, halfCheckedKeys: halfCheckKeys });
  }
  loopTreeNodes = (node, checkKeys, bChecked) => {
    if (bChecked) {
      checkKeys.push(node[this.state.keyField].toString());
    } else {
      // let keys = cb.utils.extend(true, [], checkKeys);
      let keys = [];
      checkKeys.map((key, index) => {
        // if (key == node[this.state.keyField])
        // keys.splice(index, 1);
        if (key != node[this.state.keyField].toString())
          keys.push(key);
      });
      checkKeys = keys;
    }
    if (node.children) {
      node.children.map(n => {
        checkKeys = this.loopTreeNodes(n, checkKeys, bChecked);
      });
    }
    return checkKeys;
  }
  onButtonClick = (e, type) => {
    let { multiple } = this.state;
    let model = this.getModel();
    model.execute('blur');
    let keys = [...new Set(this.checkedKeys)];
    if (type == 'submit') {
      if (this.props.onSelect)
        this.props.onSelect(keys, e);
      if (this.treeModel) {
        this.treeModel.select(keys);
        this.treeModel.check(keys);
      }
      this.referViewModel.execute('afterOkClick', multiple ? this.treeModel.getCheckedNodes() : this.treeModel.getSelectedNodes());
    }
    this.setState({ showPop: false });
  }
  onClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.onSelect)
      this.props.onSelect([], e);
    if (this.treeModel)
      this.treeModel.select([]);
    this.selectedKeys = [];
    this.setState({ checkedKeys: [], showPop: false });
    let model = this.getModel();
    model.setValue(null, true);
    model.execute('blur');
  }
  onVisibleChange = (visible) => {
    const disabled = this.state.disabled;
    if (disabled) return;
    this.setState({ showPop: visible });
    if (!visible) {
      let model = this.getModel();
      model.execute('blur');
    }
  }
  /*搜索改变*/
  onSearchChange = (e) => {
    const value = e.target.value.trim().toLocaleLowerCase();
    let data = this.state.dataSource;
    const { titleField, keyField } = this.state;
    const realTitleField = this.titleField || titleField;
    const doubleTitleField = realTitleField && realTitleField.split(',') || [];
    const loop = data => data.map((item) => {
      const needSearchStr = doubleTitleField.length ? (item[doubleTitleField[0]] + (doubleTitleField.length > 1 ? item[doubleTitleField[1]] : '') + '') : '';
      if (needSearchStr.trim().toLocaleLowerCase().indexOf(value) > -1) this.expandedKeys.push(item[keyField].toString());
      if (item.children) {
        loop(item.children);
      }
    });
    if (value != '') loop(data);

    this.setState({
      expandedKeys: this.expandedKeys,
      searchValue: value,
      autoExpandParent: true,
    });
    this.expandedKeys = [];
  }
  onExpand = (expandedKeys, node) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  }
  filterTreeNode = (node) => {
    // return ['2'];
  }
  onSearch(val) {
    debugger
  }
  onPressEnter() {
    debugger
  }
  handleBodyClick = (e) => {
    document.body.removeEventListener('click', this.handleBodyClick);
    if (this.contains(this.refs.treerefer, e.target)) return;
    // ant-popover-inner-content
    if (e.target && cb.dom(findDOMNode(e.target)).parents('div.ant-popover-inner-content').length) return;
    let model = this.getModel();
    model.execute('blur');
  }
  contains(elem, target) {
    if (elem === target)
      return true;
    if (!elem || !elem.children || !elem.children.length)
      return false;
    for (var i = 0, len = elem.children.length; i < len; i++) {
      if (this.contains(elem.children[i], target))
        return true;
    }
    return false;
  }
  onLinkageChange = (e) => {
    this.setState({
      "bLinkage": e.target.checked
    })
    this.setLocalStorege(e.target.checked);
  }
  getPopContent(treeNodes, multiple,_checkedKeys) {
    if (multiple) {
      let { checkedKeys, halfCheckedKeys, expandedKeys, autoExpandParent, searchValue, checkStrictly, bLinkage,value } = this.state;
      const treeProps = {};
      if (checkStrictly === false) {
        treeProps.checkStrictly = false;
        treeProps.checkedKeys = [].concat(checkedKeys);
      } else {
        treeProps.checkStrictly = true;
        let keys = [];
        if (checkedKeys.length > 0) {
          keys = { checked: checkedKeys, halfChecked: halfCheckedKeys };
        }
        treeProps.checkedKeys = keys;
      }
      if(!this.checkedKeys || this.checkedKeys.length == 0 && treeProps.checkedKeys && treeProps.checkedKeys.checked) {
        this.checkedKeys = treeProps.checkedKeys.checked;
        console.log(treeProps.checkedKeys)
      }
      return (
        <div>
          <Search onSearch={this.onSearch} onPressEnter={this.onPressEnter} value={searchValue} onChange={this.onSearchChange} />
          <Tree checkable onCheck={this.onCheck} {...treeProps} filterTreeNode={this.filterTreeNode}
            onExpand={this.onExpand} expandedKeys={expandedKeys} autoExpandParent={autoExpandParent}
            checkedKeys = {this.checkedKeys}
          >
            {treeNodes}
          </Tree>
          <div className="filter-btn-1">
            <Checkbox checked={bLinkage} onChange={this.onLinkageChange}>联动下级</Checkbox>
            <Button onClick={e => this.onButtonClick(e, 'submit')} className="ant-btn ant-btn-primary ant-btn-sm lf-margin">确定</Button>
            <Button onClick={e => this.onButtonClick(e, 'cancel')} className="ant-btn ant-btn-default ant-btn-sm">取消</Button>
          </div>
        </div>
      )
    } else {
      let { expandedKeys, autoExpandParent, searchValue,value } = this.state;
      return (
        <div>
          <Search onSearch={this.onSearch} onChange={this.onSearchChange} value={searchValue} />
          <Tree className='tree-refer-radio' onSelect={(selectedKeys, e) => this.onSelect(selectedKeys, e)}
            onExpand={this.onExpand} expandedKeys={expandedKeys} autoExpandParent={autoExpandParent}
            selectedKeys={this.selectedKeys}
          >
            {treeNodes}
          </Tree>
        </div>
      )
    }
  }
  getTreeRefer = () => {
    let { multiple, disabled, value, showPop } = this.state;
    let contentClass = "", showClear = false, selectionControl = null;
    if (value && value != "") {
      selectionControl = <span className="ant-select-selection-selected-value">{value}</span>;
      showClear = true;
    } else {
      selectionControl = <span className="ant-select-selection__placeholder"></span>;
    }
    if (disabled) {
      contentClass = "ant-select ant-select-disabled  ant-select-allow-clear";
    } else {
      contentClass = "ant-select ant-select-enabled ant-select-allow-clear";
    }
    if (showPop) contentClass = contentClass + '  ant-select-open ant-select-focused';

    let clearControl = (showClear ? <span onClick={this.onClear} className="ant-select-selection__clear"></span> : <span></span>)
    return (
      <span ref={node => this.input = node} onClick={this.onClick} className={contentClass}>
        <span className="uretail-treerefer-selection ant-select-selection ant-select-selection--single" role="combobox" aria-autocomplete="list" aria-haspopup="true" tabIndex="0" aria-expanded="false">
          <span className="ant-select-selection__rendered">
            {selectionControl}
          </span>
          {clearControl}
          <span className="ant-select-arrow" style={{ outline: 'none' }}>
            <b></b>
          </span>
        </span>
      </span>
    )
  }
  validate(val) {
    this.setState({
      err: 'has-' + val.type,
      msg: val.message
    });
  }
  findSelectedKeys(dataSource=[],value,keyField,valueField){
    let _this = this;
    let _selectKeys = [];
    value = cb.utils.isArray(value) ? value : value.split(',');
    dataSource.forEach(item=>{
      if(item.children){
        _selectKeys.push(_this.findSelectedKeys(item.children,value,keyField,valueField))
      }
      value.forEach(itemvalue=>{
        if(itemvalue==item[valueField]){
          _selectKeys.push(item[keyField]+"")
        }
      })
    },this)
    return _selectKeys
  }
  baseControl() {
    let baseControl = null;
    if (this.state.readOnly) {
      baseControl = text(this.state.value);
    }
    else {
      const dataSource = this.state.dataSource || [];

      let { titleField, keyField, childrenField, multiple, disabled, value, showPop, searchValue, popWidth, expandedKeys } = this.state;
      const realTitleField = this.titleField || titleField
      const doubleTitleField = realTitleField && realTitleField.split(',') || [];
      let extraTitleField = doubleTitleField.length > 1 ? doubleTitleField[1] : '' ;

      const loop = data => data.map((item) => {
        let title = item[doubleTitleField[0]] + ((extraTitleField && item[extraTitleField]) ? '(' + item[extraTitleField] + ')' : '');

        if (item[childrenField]) {
          return <TreeNode data={item} value={item[keyField]} title={title} selectable={item.selectable === false ? false : true} disabled={item.disabled} key={item[keyField].toString()}>{loop(item[childrenField])}</TreeNode>;
        }
        return <TreeNode data={item} value={item[keyField]} title={title} key={item[keyField].toString()} isLeaf={item.isLeaf} selectable={item.selectable === false ? false : true} disabled={item.disabled} />;
      });
      const resSource = [];
      const loop2 = (data, parentT) => {
        data.map((item) => {
          let title = item[doubleTitleField[0]] + ((extraTitleField && item[extraTitleField]) ? '(' + item[extraTitleField] + ')' : '');
          const parentTitle = title;
          if (parentT) {
            title = <label>
                {parentT}
                <label style={{color: '#CCCCCC'}}> / </label>
                {title}
              </label>
            // title = parentT + '' + <span style={{color: '#CCCCCC'}}>/</span>+ ' ' + title;
          }
          if (expandedKeys.indexOf(item[keyField].toString()) > -1) {
            // title = (<span style={{ color: 'red' }}>{title}</span>)
            resSource.push(<TreeNode data={item} value={item[keyField]} title={title} key={item[keyField].toString()} isLeaf={item.isLeaf} selectable={item.selectable === false ? false : true} disabled={item.disabled} />);
          }
          if (item[childrenField]) {
            loop2(item[childrenField], parentTitle)
          }
        });
        return true;
      }
      const treeNodes = searchValue && loop2(dataSource) && resSource || loop(dataSource);
      const control = this.getTreeRefer();
      const popContent = this.getPopContent(treeNodes, multiple);
      const extraProps = {};
      // if (popWidth)
      //   extraProps.overlayStyle = { width: popWidth };
      baseControl = (
        <Popover {...extraProps} visible={showPop} overlayClassName="uretail-pop treerefer-popup-container" content={popContent} trigger="click" placement="bottom" onClick={this.onPopClick} onVisibleChange={this.onVisibleChange}>
          {control}
        </Popover>
      )
    }
    return baseControl;
  }
  getControl() {
    const { bJointQuery, cShowCaption } = this.props;
    let title = bJointQuery ? <a onClick={e => this.handleJointQuery(e)}>{cShowCaption}</a> : cShowCaption;
    title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{title}</label> : <label>{title}</label>;
    let control = (cShowCaption ? <Label control={this.baseControl()} title={title} /> : this.baseControl());
    return control;
  }
  render() {
    document.body.addEventListener('click', this.handleBodyClick);
    const control = this.getControl();
    let errClass = this.state.err;
    let style = this.state.visible ? {} : { display: "none" };
    return (
      <div style={style} className={errClass ? errClass + ' has-feedback' : 'has-feedback'} ref="treerefer">
        {control}
        <div className="ant-form-explain">{this.state.msg}</div>
      </div>
    );
  }
  setLocalStorege(bFlag) {
    let item = localStorage.getItem("linkLowerLevel");
    let obj = {};
    if (item) {
      obj = JSON.parse(item);
    }
    obj[this.storageKey] = bFlag;
    localStorage.setItem("linkLowerLevel", JSON.stringify(obj));
  }
  getLocalStorege() {
    let item = localStorage.getItem("linkLowerLevel");
    if (item) {
      let obj = JSON.parse(item);
      return !!obj[this.storageKey];
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/treerefer.jsx